<div
  class="ts-trend-card"
  [style.animation-delay.ms]="delayMs"
>
  <div class="ts-trend-card__header">
    <div class="ts-trend-card__avatar">
      <img *ngIf="avatarUrl" [src]="avatarUrl" alt="" />
      <span *ngIf="!avatarUrl">{{ (displayName || handle || '?').charAt(0) }}</span>
    </div>
    <div class="ts-trend-card__names">
      <p class="ts-trend-card__name">{{ displayName }}</p>
      <p class="ts-trend-card__handle">{{ handle }}</p>
    </div>
    <span class="ts-trend-card__tag" *ngIf="tag">{{ tag }}</span>
  </div>
  <p class="ts-trend-card__content">{{ content }}</p>
  <div class="ts-trend-card__stats">
    <span>♥ {{ likes | number }}</span>
    <span>↻ {{ reposts | number }}</span>
    <span>💬 {{ comments | number }}</span>
  </div>
</div>
